import NavList from "../../nav/nav-list";
import SiteFooter from "../../custom/site-footer/site-footer";
import HeroCarousel from "../../custom/hero-carousel/hero-carousel";
import SectionHead from "../../custom/section-head/section-head";
import CardRail from "../../custom/card-rail/card-rail";
import ReviewCard from "../../custom/review-card/review-card";
import {
  HERO_SLIDES,
  HOT_PRODUCTS,
  LOVE_PRODUCTS,
} from "../../../constant/home-content";
import { HOME_REVIEW_COUNT } from "../../../constant/review-content";
import useReviews from "../../../hooks/useReviews";
import "./home-page-style.scss";

//首頁（探索）
//
//  這一頁只負責「組裝」：資料從 constant/home-content 來，版型全在共用元件裡。
//  之後新增區塊 = 加一個 <section>，新增產品 = 改資料，不用動版型。
//  接後端時把 import 的 constant 換成 API 回傳即可，元件吃的資料形狀一樣。
//
//  頂部列與頁尾由本頁自己掛（不在 MainLayout）—— 次層頁面用的是 SubHeader，
//  兩種頂部列結構差很多，由各頁決定比在外框寫路由判斷清楚。
const HomePageComponent = () => {
  //真實評價累積到一定則數才換掉備援那份，兩者不混著放（見 useReviews）
  const { reviews } = useReviews();

  return (
    <>
      <NavList />

      <main className="home">
        <HeroCarousel slides={HERO_SLIDES} />

        <section className="home__section container">
          <SectionHead
            eyebrow="熱門體驗"
            title="最多人在看的命理服務"
          />
          <CardRail items={HOT_PRODUCTS} perView={3} />
        </section>

        <section className="home__section container">
          <SectionHead
            eyebrow="戀愛不順時"
            title="先檢視自己的魅力"
          />
          <CardRail items={LOVE_PRODUCTS} perView={3} />
        </section>

        <section className="home__section container">
          <SectionHead
            eyebrow="真實回饋"
            title="現在最熱門的顧客評價"
            morePath="/reviews"
          />
          <p className="home__section-note">
            啓示錄命理引以為傲的 100% 真實評價。
          </p>

          {/* 首頁只放前幾則，其餘在 /reviews ——
              「看更多」要真的有更多可看，不然那顆按鈕只是裝飾。 */}
          <div className="home__reviews">
            {reviews.slice(0, HOME_REVIEW_COUNT).map((review) => (
              <ReviewCard key={review.id} review={review} />
            ))}
          </div>
        </section>
      </main>

      <SiteFooter />
    </>
  );
};

export default HomePageComponent;
